import React from 'react';
import NiceModal from "@ebay/nice-modal-react";
import Gamepads from '@components/Gamepad';
import BotTestDrive from '@components/BotTestDrive';

const App = () => {
    return (
        <Gamepads>
            <BotTestDrive />
        </Gamepads>
    )
}

export default App
